import get from 'lodash/get';

const Format = {};

/**
 * Formats raw prismic post data into a format suited to pinned post components
 * @return {Object}      formatted post
 */
Format.formatPinnedPost = post => ({
  uid: post.uid,
  title: get(post, 'data.title[0].text', ''),
  introText: get(post, 'data.intro_text[0].text', ''),
  cover: get(post, 'data.cover', ''),
});

export default Format;
